import {Injectable} from '@angular/core';
import {FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

@Injectable()
export class FormValidationService {
  public emailPattern: RegExp =
    /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  public phonePattern: RegExp = /^[0-9\-\+\ \(\)]+/g;

  public comparePasswords: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const password = control.get('password');
    const passwordConfirmation = control.get('confirm_password');
    return password && password.value && passwordConfirmation && passwordConfirmation.value &&
    password.value !== passwordConfirmation.value ? { 'differentPasswords': true } : null;
  }

  public creditCardNumberSupportedValidator(control) {
    // if (control.value.match(/(^(?!^(4026|417500|4405|4508|4844|4913|4917))(?=^4))|(^(?!^(5018|5020|5038|5612|5893|5019))(?=^5[0-5][0-9]))/)) {
    if (control.value.replace( /\D/g, '' ).match(/(^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$)|(^4[0-9]{12}(?:[0-9]{3})?$)/g)) {
      return null;
    } else {
      return { 'numberNotSupportedCreditCard': true };
    }
  }

  public isExpiryDateValid(control) {
    const curDate = new Date();
    const arrYear = String(curDate.getFullYear()).split('');
    const arrMaxYear = String(curDate.getFullYear() + 6).split('');
    let expYear;
    if (arrYear[2] == arrMaxYear[2] && Number(arrMaxYear[3]) <= 9) {
      expYear = arrYear[2] + '[' + arrYear[3] + '-' + arrMaxYear[3] + ']';
    } else {
      expYear = arrYear[2] + '[' + arrYear[3] + '-9]|' + arrMaxYear[2] + '[0-' + arrMaxYear[3] + ']';
    }
    const expDateRegExp = new RegExp('^(0[1-9]|1[0-2])(\/|-)(' + expYear + ')$', 'g');
    if (control.value.match(expDateRegExp)) {
      return null;
    } else {
      return { 'expiryDatePattern': true };
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/form-validation.service.ts